import { useEffect } from 'react';

export default function MetaPixel({ pixelId }) {
  useEffect(() => {
    const id = String(pixelId || '').replace(/\D/g, '');
    if (!id || document.getElementById(`meta-pixel-${id}`)) return;

    // Cola oficial de Meta: permite registrar eventos aunque el script externo
    // todavía esté descargándose, sin romper la aplicación si tarda en cargar.
    const fbq = window.fbq || function (...args) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
      } else {
        fbq.queue.push(args);
      }
    };
    window.fbq = fbq;
    window._fbq = window._fbq || fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = fbq.queue || [];

    const script = document.createElement('script');
    script.id = `meta-pixel-${id}`;
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onerror = () => console.warn('No fue posible cargar Meta Pixel. Verifica tu conexión o bloqueador de anuncios.');
    document.head.appendChild(script);

    fbq('init', id);
    fbq('track', 'PageView');
  }, [pixelId]);
  return null;
}
